import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Faktur Pajak',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Faktur Pajak',
        href: '/adm/fin/laporan/faktur-pajak',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeFakturPajak(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListFakturPajak({ commit, state }) {
    commit('changeFakturPajak', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/laba-rugi`, data.form);
    commit('changeFakturPajak', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
